import axios from 'axios'
import qs from 'qs'
import { servicePath } from '../../project.config'
import { getValidityToken } from '../utils/tools'


export const login = (credentials, callback) => {

  const params = qs.stringify({
    userId: credentials.userId,
    userType: credentials.userType,
    Watchword: credentials.watchword,
    platform: '1', // web:1, android:2, ios:3
    loginAttemt: credentials.loginAttemt,
    captcha: credentials.captcha,
    operationType: credentials.operationType || null,
    validityToken: getValidityToken()
  });
  // console.log('parametreler : ',params);
  // console.log('credentials:', credentials);
  const header = { 'Content-Type': 'application/x-www-form-urlencoded', 'Platform': '1' };
  //axios.post(`${servicePath}/Account/Login`, header, params)
  axios({
    method: 'post',
    headers: header,
    url: `${servicePath}/Account/Login`,
    data: params
  })
    .then((response) => {
      if (response.status === 200 && !response.data.hasError && response.data.auth_token) {
        // console.log('enterprise login response:', response);
        setToken(response.data.auth_token);
        setUserInformation({
          firstname: response.data.firstName,
          lastname: response.data.lastName,
          email: response.data.email,
          tckn: response.data.tcNo,
          phone: response.data.phone ? response.data.phone : '',
          homePhone: response.data.homePhone ? response.data.homePhone : '',
          userId: credentials.userId,
          userType: credentials.userType,
          customerNo: response.data.customerNo,
          taxNo: response.data.vergi_no ? response.data.vergi_no : '',
          validityToken: getValidityToken()
        });
        return callback({ succ: true, mess: "" });
      }
      if (response.status === 200 && response.data.hasError && (response.data.sonucKodu === '30E009' || response.data.sonucKodu === '30E004')) { // güvenlik kodu hatası 30E009
        return callback({ succ: false, mess: "KODHATA" });
      }
      return callback({ succ: false, mess: "" });
    })
    .catch((error) => {
      return callback({ succ: false, mess: "" });
    });
}

export const register = (user) => {
  return axios.post(`${servicePath}/users`, user);
}

export const isAuthenticated = () => {
  const token = getToken();
  const userId = sessionStorage.getItem('userId');
  const userType = sessionStorage.getItem('userType');

  return !!token && !!userId && !!userType;
}

export const getToken = () => {
  return sessionStorage.getItem('token');
}

export const setToken = (token) => {
  return sessionStorage.setItem('token', token);
}

export const removeToken = () => {
  sessionStorage.removeItem('at');
  return sessionStorage.removeItem('token');
}

export const setUserInformation = (data) => {
  sessionStorage.setItem('firstname', data.firstname);
  sessionStorage.setItem('lastname', data.lastname);
  sessionStorage.setItem('tckn', data.tckn);
  sessionStorage.setItem('phone', data.phone);
  sessionStorage.setItem('homePhone', data.homePhone);
  sessionStorage.setItem('email', data.email);
  sessionStorage.setItem('userId', data.userId);
  sessionStorage.setItem('userType', data.userType);
  sessionStorage.setItem('customerNo', data.customerNo);
  sessionStorage.setItem('taxNo', data.taxNo);
  sessionStorage.setItem('edevletDogrulama', data.edevletDogrulama);
  sessionStorage.setItem('validityToken', getValidityToken());
}

export const getUserInformation = () => {
  const userInfo = {
    firstname: sessionStorage.getItem('firstname'),
    lastname: sessionStorage.getItem('lastname'),
    tckn: sessionStorage.getItem('tckn'),
    phone: sessionStorage.getItem('phone'),
    homePhone: sessionStorage.getItem('homePhone'),
    email: sessionStorage.getItem('email'),
    userId: sessionStorage.getItem('userId'),
    userType: sessionStorage.getItem('userType'),
    customerNo: sessionStorage.getItem('customerNo'),
    taxNo: sessionStorage.getItem('taxNo'),
    edevletDogrulama: sessionStorage.getItem('edevletDogrulama'),
    validityToken: sessionStorage.getItem('validityToken'),
  }
  return userInfo;
}

export const isIstanbulLogin = () => {
  const userInfo = getUserInformation();
  if (userInfo.userPlatform == undefined || userInfo.userPlatform == "undefined") {
    return false;
  }
  return true;
}


export const clearUserInformation = () => {
  sessionStorage.removeItem('firstname');
  sessionStorage.removeItem('lastname');
  sessionStorage.removeItem('tckn');
  sessionStorage.removeItem('phone');
  sessionStorage.removeItem('homePhone');
  sessionStorage.removeItem('email');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('userType');
  sessionStorage.removeItem('customerNo');
  sessionStorage.removeItem('taxNo');
  sessionStorage.removeItem('userPlatform');
  sessionStorage.removeItem('edevletDogrulama');
  sessionStorage.removeItem('validityToken');
}

export const authCheck = (nextState, replace) => {
  if (!isAuthenticated()) {
    const pathname = nextState.location.pathname;
    let search = nextState.location.search || "";
    search = search.replace(/&amp;/g, "&");

    const currentUrl = pathname + search;

    if (
      pathname === "/dashboard" &&
      search.indexOf("action=cancel-installment") > -1
    ) {
      sessionStorage.setItem("after_login_redirect_url", currentUrl);
    }

    replace({
      pathname: "/login",
      state: { nextPathname: currentUrl }
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js